/**
 * LogsTab — resident activity log. All behavior lives in the shared
 * ProfileLogsTable; this only supplies what differs per entity.
 *
 * The actor links to their user profile when they belong to this community (see
 * actorLinkable in ProfileLogsTable).
 */

import ProfileLogsTable from '../../../../../components/v2/ProfileLogsTable.jsx';

const LogsTab = ({ logData, tzOffset, showInternal = true }) => (
  <ProfileLogsTable
    logData={logData}
    tzOffset={tzOffset}
    typeKey="resident_log_type_name"
    title="Resident Logs"
    linkUsers
    showInternal={showInternal}
  />
);

export default LogsTab;
